export const DEFAULTS = {
  data: {
    captcha: '',
    national_code: '',
    mobile: '',
    company_type: '',
    password: ''
  },
  validation: {
    national_code: undefined,
    mobile: undefined,
    password: undefined,
    pin: undefined
  }
};
